function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDateTransferredi = function SvgDateTransferredi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.348 0H24v24H.348z",
    style: {
      fill: "none"
    },
    transform: "matrix(1.01339 0 0 1 -.35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2161.3 78.246h-5.32c-.38 0-.7.313-.7.7s.32.7.7.7h5.25l-1.07 1.037a.697.697 0 0 0-.01.99.7.7 0 0 0 .99.015l2.22-2.157a.7.7 0 0 0 .25-.278.8.8 0 0 0 .09-.343c0-.189-.08-.37-.22-.502l-2.27-2.205a.7.7 0 0 0-.99.016.696.696 0 0 0 .02.989zm-3.08-14.076h-3.59v-.989c0-.386-.31-.7-.7-.7-.38 0-.7.314-.7.7v.989h-3.46v-.989c0-.386-.31-.7-.7-.7s-.7.314-.7.7v.989h-2.4c-.93 0-1.7.762-1.7 1.7v14.311c0 .939.77 1.7 1.7 1.7h8.02c.39 0 .7-.313.7-.7s-.31-.7-.7-.7h-8.02c-.16 0-.3-.134-.3-.3v-9.876h16.64v1.133c0 .386.31.7.7.7s.7-.314.7-.7V65.87a1.7 1.7 0 0 0-1.7-1.7h-2.39v-.989c0-.386-.32-.7-.71-.7-.38 0-.69.314-.69.7zm-2.86 10.217c.05.113.14.209.24.278l2.22 2.157c.28.269.73.262 1-.015a.706.706 0 0 0-.02-.99l-1.07-1.037h5.25c.39 0 .7-.314.7-.7 0-.387-.31-.7-.7-.7h-5.32l1.07-1.038a.7.7 0 0 0-.98-1.005l-2.27 2.205a.68.68 0 0 0-.21.502c0 .121.03.239.09.343m-6.99-8.817h-2.4c-.16 0-.3.135-.3.3v3.035h16.64V65.87c0-.165-.13-.3-.3-.3h-2.39v.989c0 .386-.32.7-.71.7a.696.696 0 0 1-.69-.7v-.989h-3.59v.989c0 .386-.31.7-.7.7-.38 0-.7-.314-.7-.7v-.989h-3.46v.989c0 .386-.31.7-.7.7s-.7-.314-.7-.7z",
    style: {
      fill: "#123456"
    },
    transform: "translate(-2142.008 -60.181)"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDateTransferredi);
export default ForwardRef;